import { render } from "./EditProposalGeneralInfo.vue?vue&type=template&id=c9edaeac&scoped=true"
import script from "./EditProposalGeneralInfo.vue?vue&type=script&lang=js"
export * from "./EditProposalGeneralInfo.vue?vue&type=script&lang=js"

import "./EditProposalGeneralInfo.vue?vue&type=style&index=0&id=c9edaeac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9edaeac"]])

export default __exports__